import React, { useState, useEffect, Suspense } from "react";
import "./style.css";
import { useLocation } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import BlogsService from "../Services/blogs.service";

import AOS from "aos";
import "aos/dist/aos.css";


function Blog() {
  const location = useLocation();
  const { blogId } = location.state;

  const [blogs, setBlogs] = useState({});
  const [mainBlogs, setMainBlogs] = useState([]);
  const [blogDesc, setBlogDesc] = useState([]);
  const [blogID, setBlogID] = useState(blogId);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchBlogs();
  }, [blogID]);

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
  }, []);

  const fetchBlogs = () => {
    BlogsService.fetchBlogsData()
      .then((resp) => {
        if (resp.data) {
          console.log(resp.data);
          const matchedBlog = resp.data.find((blog) => blog.id === blogID);
          setMainBlogs(resp.data);
          if (matchedBlog) {
            setBlogs(matchedBlog);
            const segments = matchedBlog.description.split("\r\n\r\n");
            const formattedSegments = segments.map((segment) =>
              segment.replace(/\r\n/g, "\n")
            );
            console.log("formattedSegments", formattedSegments);
            setBlogDesc(matchedBlog.description);
          } else {
            console.error("No blog found with the specified id");
          }
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const options = {
    margin: 30,
    responsiveClass: true,
    nav: false,
    dots: true,
    autoplay: true,
    navText: ["Prev", "Next"],
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1, // Changed mainBlogs to items
      },
      600: {
        items: 2, // Changed mainBlogs to items
      },
      1000: {
        items: 3, // Changed mainBlogs to items
      },
    },
  };

  return (
    <>
      <div className="blogs-banner">
        <div className="bgoverlay"></div>
        <div className="container-fluid">
          <div className="blogs-content">
            <div className="row">
              <div className="col-lg-6">
                <div className="heading">
                  <div className="heading-flex" data-aos="fade-right" data-aos-duration="1500">
                    {/* <h2>{blogs.title}</h2> */}
                    <h4>{blogs.title}</h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <img
                  src={`https://fidusindia.in/cit/assets/blog_images/${blogs.image}`}
                  className="img-fluid"
                  alt=""
                  data-aos="fade-left" data-aos-duration="1500"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="blogs-section">
        <div className="blogs-banner-circle"></div>
        <div className="blogs-section-content">
          {/* {Array.isArray(blogDesc)
            ? blogDesc.map((paragraph, index) => (
                <p key={index}>
                  {paragraph.split("\n").map((line, lineIndex) => (
                    <React.Fragment key={lineIndex}>
                      {line}
                      {lineIndex < paragraph.split("\n").length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              ))
            : null} */}

          <div
            dangerouslySetInnerHTML={{
              __html: blogDesc && blogDesc,
            }}
            data-aos="fade-up" data-aos-duration="1500"
          />
        </div>
        <OwlCarousel className="owl-theme" {...options} loop>
          {Array.isArray(mainBlogs) && mainBlogs.length > 0
            ? mainBlogs.map((item) => (
                <div
                  key={item.id}
                  className="item"
                  style={{ height: "300px" }}
                  onClick={() => setBlogID(item.id)}
                >
                  <img
                    src={`https://fidusindia.in/cit/assets/blog_images/${item.image}`}
                    className="img-fluid"
                    alt=""
                  />
                  <div className="blog-op"></div>
                  <div className="blog-cowl-text">
                    <h6>{item.title}</h6>
                    <div>Read more</div>
                  </div>
                </div>
              ))
            : null}
        </OwlCarousel>
      </div>
    </>
  );
}

export default Blog;
